<template functional>
  <section class="user-details">
    <div class="user-details__card">
      <div class="user-details__avatar-wrapper">
        <img class="user-details__avatar" :src="props.avatar" />
        <p class="user-details__user-name">{{ props.userName }}</p>
      </div>
      <div class="user-details__details-wrapper">
        <div class="user-details__details-item">
          <p class="lead">Email:</p>
          <p class="data">{{ props.userEmail }}</p>
        </div>
        <div v-show="!isCordova" class="user-details__details-item">
          <p class="lead">Pass:</p>
          <p class="data">*******</p>
          <a
            :href="`https://${props.membersUrl}/profile#password-tab`"
            class="user-details__password-btn"
            >Edit</a
          >
        </div>
      </div>
      <div v-show="!isCordova" class="user-details__dashboard-btn-wrapper">
        <a
          class="user-details__dashboard-btn"
          :href="`https://${props.membersUrl}/`"
        >
          Visit Members Dashboard
          <span class="material-icons">link</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UserDetailsCard',
  props: {
    avatar: {
      type: String,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
    membersUrl: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.user-details {
  display: none;
  justify-content: center;
  margin: 58px 0;
  @include tablet {
    display: flex;
    margin: 58px 32px 0 0;
  }
  &__card {
    width: 100%;
    background-color: var(--light-gray);
    height: 400px;
    position: relative;
    margin: 0 0 50px 0;
    @include mobile {
      width: 400px;
    }
  }
  &__avatar-wrapper {
    padding: 65px 65px 0 65px;
  }
  &__avatar {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 100px;
  }
  &__avatar-image {
    border-radius: 100%;
    margin-bottom: 10px;
    height: 100px;
    width: auto;
  }
  &__user-name {
    color: var(--white);
    font-size: 1.5rem;
    text-transform: uppercase;
    padding: 0 0 20px;
    margin: 0 0 45px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    text-align: center;
  }
  &__details-wrapper {
    color: var(--white);
    padding: 0px 65px 25px 65px;
    margin: 0 0 35px;
  }
  &__details-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    @include mobile {
      justify-content: flex-start;
    }
  }
  &__password-btn {
    background-color: transparent;
    border: none;
    color: var(--white);
    margin: -15px 0 0 auto;
    cursor: pointer;
    transition: 0.5s all ease;
    text-decoration: underline;
    &:hover {
      color: var(--orange);
      border-color: var(--orange);
    }
  }
  &__dashboard-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--flat-black);
    height: 66px;
  }
  &__dashboard-btn {
    color: var(--white);
    display: inline-block;
    transition: 0.5s all ease;
    font-size: 16px;
    &:hover {
      color: var(--orange);
      border-color: var(--orange);
    }
  }
  .lead {
    font-size: 18px;
  }
  .data {
    font-size: 18px;
  }
  .material-icons {
    margin: 0 0 0 10px;
    font-size: 20px;
  }
}
</style>
